import { createBrowserHistory } from 'history';
import { History } from 'history';

type ReadonlyBrowserHistory = Readonly<History>
export const browserHistory: ReadonlyBrowserHistory = createBrowserHistory();